var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 40,
    viewBox: "0 0 39 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_65_420)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.9326,
    y: 28.4326,
    width: 16.8652,
    height: 16.8652,
    transform: "rotate(-180 27.9326 28.4326)",
    fill: "#F6557F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.4999,
    y: 28.5713,
    width: 12.1218,
    height: 12.1218,
    transform: "rotate(-135 19.4999 28.5713)",
    fill: "#FF7FA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5001 32.6489L11.0675 28.4326L27.9326 28.4326L19.5001 32.6489Z",
    fill: "#FF7095"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9326 11.5674L27.9326 9.0376L30.4623 11.5674L27.9326 11.5674Z",
    fill: "#FF7095"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0674 11.5674L11.0674 9.0376L8.53767 11.5674L11.0674 11.5674Z",
    fill: "#FF7095"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9326 28.4326L27.9326 30.9624L30.4623 28.4326L27.9326 28.4326Z",
    fill: "#FF7095"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0674 28.4326L11.0674 30.9624L8.53766 28.4326L11.0674 28.4326Z",
    fill: "#FF7095"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.85121 19.9997L11.0675 11.5671L11.0675 28.4323L6.85121 19.9997Z",
    fill: "#FF7095"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 7.35106L11.0674 11.5673L27.9326 11.5673L19.5 7.35106Z",
    fill: "#FF7095"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1492 19.9997L27.9329 11.5671L27.9329 28.4323L32.1492 19.9997Z",
    fill: "#FF7095"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8949 20L30.4623 11.5674L27.9325 11.5674L32.1488 20L38.8949 20Z",
    fill: "#FF91AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 39.3948L27.9326 30.9621L27.9326 28.4324L19.5 32.6487L19.5 39.3948Z",
    fill: "#FF91AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.105073 20L8.53773 11.5674L11.0675 11.5674L6.85121 20L0.105073 20Z",
    fill: "#FF91AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5001 0.60498L27.9326 9.03764L27.9326 11.5674L19.5 7.35112L19.5001 0.60498Z",
    fill: "#FF91AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.895 20L30.4623 28.4326L27.9326 28.4326L32.1489 20L38.895 20Z",
    fill: "#F36488"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5001 39.3948L11.0676 30.9621L11.0676 28.4324L19.5002 32.6487L19.5001 39.3948Z",
    fill: "#F36488"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.105175 19.9998L8.53783 28.4323L11.0676 28.4323L6.85132 19.9998L0.105175 19.9998Z",
    fill: "#F36488"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 0.60498L11.0675 9.03764L11.0675 11.5674L19.5 7.35112L19.5 0.60498Z",
    fill: "#F36488"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_65_420"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.5,
    y: 0.60498,
    width: 27.4286,
    height: 27.4286,
    rx: 3.42857,
    transform: "rotate(45 19.5 0.60498)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2c05de8c8067ce07b17492808a8e8d91.svg";
export { ForwardRef as ReactComponent };